import gettext from '@sdk/lang/gettext';
import Column from '@sdk/components/ui/spacing/Column';

import SettingsSwitcherRow from '@web/settings/components/SettingsSwitcherRow';
import BreaksContent from '@web/settings/components/schedule/Breaks/BreaksContent/BreaksContent';
import { useBreaks } from '@web/settings/components/schedule/Breaks/breaks.hooks';

const Breaks = () => {
  const { currentUser, areBreaksEnabled, setBreaksAreEnabled } = useBreaks();

  return (
    <Column>
      <SettingsSwitcherRow
        disabled={!currentUser.isAdmin}
        subtitle={gettext('Enable employees to take breaks during their shifts.')}
        value={areBreaksEnabled}
        onChange={(value: boolean): void => setBreaksAreEnabled(value)}
      />

      {areBreaksEnabled && <BreaksContent />}
    </Column>
  );
};

export default Breaks;
